












































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import HhSurveilansService from "@/services/HhSurveilansService";
import HhSurveilansObservasiLogger from "./HhSurveilansObservasiLogger.vue";
import HhSurveilansDetail from "./HhSurveilansDetail.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import { userModule } from "@/store/modules/user";

@Component({
  components: { HhSurveilansObservasiLogger, HhSurveilansDetail, UnitRuangPicker }
})
export default class HhSurveilansList extends Vue {
  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterUnit: string | null = null;
  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;

  form: any = {
    unit_id: "",
    unit_nama: "",
    periode_mulai: "",
    periode_akhir: "",
    shift: "pagi",
    auditor_nip: "",
    auditor_jabatan: "",
    auditor_str_sip: ""
  };

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted Auditor", value: "submitted" },
    { text: "Approved Tim PPI", value: "approved_tim_ppi" },
    { text: "Approved Pimpinan", value: "approved_pimpinan" },
    { text: "Closed", value: "closed" }
  ];

  kategoriOptions = [
    { text: "Patuh (≥85%)", value: "patuh" },
    { text: "Perlu Peningkatan (70–84%)", value: "perlu_peningkatan" },
    { text: "Tidak Patuh (<70%)", value: "tidak_patuh" }
  ];

  shiftOptions = [
    { text: "Pagi", value: "pagi" },
    { text: "Sore", value: "sore" },
    { text: "Malam", value: "malam" }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Periode", value: "periode" },
    { text: "Unit", value: "unit_nama" },
    { text: "Auditor", value: "auditor_nama" },
    { text: "Shift", value: "shift" },
    { text: "Indikasi", value: "jumlah_indikasi", width: 70 },
    { text: "Compliance", value: "compliance_rate" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 120 }
  ];

  get namaAuditor(): string {
    return userModule.user?.nama || "-";
  }

  get bolehLintasUnit(): boolean {
    return (
      userModule.isSuperAdmin ||
      userModule.hasAssignedPrivilege("surveilans_hh", "view")
    );
  }

  get unitTerkunci(): boolean {
    if (!userModule.scopedUnitId) return false;
    return userModule.isUnitScopeLocked || !this.bolehLintasUnit;
  }

  async mounted() {
    this.filterUnit = userModule.scopedUnitId;
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterUnit) params.unit_id = this.filterUnit;
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.kategori_kepatuhan = this.filterKategori;
      const res = await HhSurveilansService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    this.form.periode_akhir = localISODate();
    this.form.periode_mulai = localISODate();
    this.form.unit_id = userModule.scopedUnitId || "";
    this.form.unit_nama = "";
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    this.creating = true;
    try {
      const res = await HhSurveilansService.create(this.form);
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    HhSurveilansService.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  getComplianceColor(rate: number) {
    if (!rate) return "grey";
    if (rate >= 85) return "success";
    if (rate >= 70) return "warning";
    return "error";
  }
}
